import React from "react";
import { ShippingRates, CurrencyRates, ContactFields, SalesWindow, LogoField } from "./shipping/SettingsSections";
import { HeroMedia } from "./shipping/HeroMedia";

export function ShippingTab({ ctx }) {
  const { settings, setSettings, logoUploading, heroUploading, heroUrl, setHeroUrl, uploadLogo, uploadHero, removeHero, saveSettings } = ctx;
  const patch = (key, value) => setSettings({ ...settings, [key]: value });
  const common = { settings, patch };
  return (
    <div className="max-w-lg">
      <h1 className="serif text-3xl mb-2">Shipping · الشحن</h1>
      <p className="text-sm text-[#8A857D] mb-8">أسعار التوصيل بالدرهم. داخل الإمارات حسب المنطقة، والخليج بري أو جوي حسب الوزن. اضغط حفظ بعد التعديل. / Delivery prices in AED: UAE by area, GCC land or air by weight. Press Save after editing.</p>
      <div className="space-y-3">
        <ShippingRates {...common} />
        <CurrencyRates {...common} />
        <ContactFields {...common} />
        <SalesWindow {...common} />
        <LogoField {...common} uploading={logoUploading} onUpload={uploadLogo} />
        <HeroMedia {...common} setSettings={setSettings} uploading={heroUploading} onUpload={uploadHero} onRemove={removeHero} heroUrl={heroUrl} setHeroUrl={setHeroUrl} />
      </div>
      <button onClick={saveSettings} data-testid="save-settings" className="mt-6 bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.2em] px-8 py-3 hover:bg-[#E7CBA9]">Save</button>
    </div>
  );
}
